var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Swiper',{attrs:{"swiper":_vm.swipe}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about"},[_c('section',[_c('h1',[_vm._v("我们是设计师、工程师、梦想者"),_c('br'),_vm._v(" 也是您的用户体验专家 ")]),_c('p',[_vm._v("我们是一家专注用户体验设计开发与互联网品牌建设的设计公司，创立至今为200多位客户提供了创新与专业的设计方案。设计服务范围包括：交互原型设计、产品视觉设计、网站设计与开发建设、移动及软件产品界面设计、图标设计、品牌及平面设计等。我们的价值与宗旨是为用户和客户打造最nice的设计，用设计提升产品和企业价值。")])])])
}]

export { render, staticRenderFns }